import { useEffect, useRef, useState } from 'react';
import { getAppVersion, clearAuthStorage } from '../services/api';

const VERSION_KEY = 'app_version';
const CHECK_INTERVAL_MS = 10 * 1000; 

const useVersionCheck = () => {
    const intervalRef = useRef(null);
    const [isVersionChecked, setIsVersionChecked] = useState(false);

    const checkVersion = async () => {
        const latestVersion = await getAppVersion();

        if (!latestVersion) {
            // API 失敗，不能卡住畫面，直接放行
            setIsVersionChecked(true);
            return;
        }

        const storedVersion = localStorage.getItem(VERSION_KEY);

        if (!storedVersion) {
            // 第一次訪問，寫入版本號，不 reload
            localStorage.setItem(VERSION_KEY, latestVersion);
            setIsVersionChecked(true);
            return;
        }

        if (storedVersion !== latestVersion) {
            console.log(`[版本更新] ${storedVersion} → ${latestVersion}，清除登入狀態並重新載入`);
            clearAuthStorage();
            localStorage.setItem(VERSION_KEY, latestVersion);
            if ('caches' in window) {
                try {
                    const cacheNames = await caches.keys();
                    await Promise.all(cacheNames.map(name => caches.delete(name)));
                } catch (e) { }
            }
            window.location.reload(true);
            return;
        }

        setIsVersionChecked(true);
    };

    useEffect(() => {
        checkVersion();
        intervalRef.current = setInterval(checkVersion, CHECK_INTERVAL_MS);
        return () => {
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { isVersionChecked };
};

export default useVersionCheck;